// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27white%27%3E%3Cpath d=%27M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.winner-info,
.choice-section label {
  font-weight: 700;
}

.choice-section {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.choice-section label {
  font-size: 1.6rem;
  color: #2c3948;
}

.choice-section select {
  padding: 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.4rem;
  font-size: 1.6rem;
  min-width: 20rem;
}

.winner {
  background-color: #fef3e7;
  padding: 0.5rem 1rem;
  margin-left: 1rem;
  border-radius: 0.4rem;
}

.selection-section {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.voir-details {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  background: none;
  border: none;
  color: #f4751b;
  font-size: 1.6rem;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  color: #2c3948;
  text-decoration: underline;
}

.voir-details svg {
  width: 20px;
  height: 20px;
}

.voir-details:hover {
  opacity: 0.8;
}

.note-total {
  font-weight: 700;
}

.note-badge {
  background: #da7027;
  color: #fffdfc;
  font-size: 1.6rem;
  min-width: 4.5rem;
  border-radius: 2rem;
  padding: 0.2rem 1.2rem;
  display: inline-block;
  text-align: center;
}

.presta-col.selected {
  border: 3px solid #004681;
  background-color: rgba(0, 70, 129, 0.05);
}

.presta-col.best-note.selected {
  border: 3px solid #da7027;
  /* outline: 3px solid #004681; */
  outline-offset: -6px;
}

.best-note-badge {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #da7027;
  color: white;
  padding: 4px 12px;
  border-radius: 16px;
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 2;
  width: 192px;
}

.expired-badge {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #6b7280;
  color: white;
  padding: 4px 12px;
  border-radius: 16px;
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 2;
  width: 192px;
  text-align: center;
}

.choix-prestataire-instructions {
  margin-bottom: 1.5rem;
  padding: 1rem;
  background-color: rgba(215, 217, 217, 0.2);
  border-left: 4px solid #004681;
  border-radius: 4px;
}

.presta-col.clickable {
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}

.presta-col.clickable:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}

.presta-col.best-note {
  border: 3px solid #da7027;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.15);
}

.presta-selection-indicator {
  margin-top: 1.5rem;
  text-align: center;
  padding: 0.8rem;
  border-top: 1px solid #e5e7eb;
}

.selected-label {
  font-weight: 600;
  color: #004681;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.selected-label::before {
  content: "";
  display: inline-block;
  width: 18px;
  height: 18px;
  background-color: #004681;
  border-radius: 50%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 12px 12px;
  background-repeat: no-repeat;
  background-position: center;
}

.not-selected-label {
  color: #6b7280;
  font-size: 0.9rem;
}

.form-row.note-ponderee {
  grid-template-columns: 40% 60%;
}

.ponderation-badge {
  display: inline-block;
  font-size: 0.95rem;
  font-weight: 500;
  padding: 2px 6px;
  border-radius: 8px;
  margin-left: 6px;
  background-color: rgba(215, 217, 217, 0.25);
  color: #595959;
}

.info-icon-container {
  position: relative;
  display: inline-block;
  margin-left: 4px;
  cursor: help;
}

.info-icon {
  display: block;
}

.info-icon-container .tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #595959;
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  width: 300px;
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s, visibility 0.2s;
  z-index: 10;
  font-size: 1rem;
  pointer-events: none;
  margin-top: 5px;
}

.info-icon-container:hover .tooltip {
  visibility: visible;
  opacity: 1;
}

/* Flèche du tooltip */
.info-icon-container .tooltip::before {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 10px;
  border-width: 6px;
  border-style: solid;
  border-color: transparent transparent #2c3948 transparent;
}

.note-detail {
  font-size: 1.2rem;
  color: #6b7280;
  margin-left: 0.5rem;
}

.ponderation-badge {
  display: inline-block;
  padding: 0.2rem 0.6rem;
  border-radius: 1rem;
  font-size: 1.2rem;
  font-weight: 600;
  margin-left: 0.5rem;
  background-color: rgba(215, 217, 217, 0.2);
}
`, "",{"version":3,"sources":["webpack://./src/composants/SyntheseAnalyse/SyntheseAnalyse.css"],"names":[],"mappings":"AAAA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,0CAA0C;EAC1C,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yDAAoM;EACpM,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,yCAAyC;EACzC,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C","sourcesContent":[".winner-info,\n.choice-section label {\n  font-weight: 700;\n}\n\n.choice-section {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n}\n\n.choice-section label {\n  font-size: 1.6rem;\n  color: #2c3948;\n}\n\n.choice-section select {\n  padding: 1rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.4rem;\n  font-size: 1.6rem;\n  min-width: 20rem;\n}\n\n.winner {\n  background-color: #fef3e7;\n  padding: 0.5rem 1rem;\n  margin-left: 1rem;\n  border-radius: 0.4rem;\n}\n\n.selection-section {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.voir-details {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  background: none;\n  border: none;\n  color: #f4751b;\n  font-size: 1.6rem;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0;\n  color: #2c3948;\n  text-decoration: underline;\n}\n\n.voir-details svg {\n  width: 20px;\n  height: 20px;\n}\n\n.voir-details:hover {\n  opacity: 0.8;\n}\n\n.note-total {\n  font-weight: 700;\n}\n\n.note-badge {\n  background: #da7027;\n  color: #fffdfc;\n  font-size: 1.6rem;\n  min-width: 4.5rem;\n  border-radius: 2rem;\n  padding: 0.2rem 1.2rem;\n  display: inline-block;\n  text-align: center;\n}\n\n.presta-col.selected {\n  border: 3px solid #004681;\n  background-color: rgba(0, 70, 129, 0.05);\n}\n\n.presta-col.best-note.selected {\n  border: 3px solid #da7027;\n  /* outline: 3px solid #004681; */\n  outline-offset: -6px;\n}\n\n.best-note-badge {\n  position: absolute;\n  top: -12px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #da7027;\n  color: white;\n  padding: 4px 12px;\n  border-radius: 16px;\n  font-weight: 600;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  z-index: 2;\n  width: 192px;\n}\n\n.expired-badge {\n  position: absolute;\n  top: -12px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #6b7280;\n  color: white;\n  padding: 4px 12px;\n  border-radius: 16px;\n  font-weight: 600;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  z-index: 2;\n  width: 192px;\n  text-align: center;\n}\n\n.choix-prestataire-instructions {\n  margin-bottom: 1.5rem;\n  padding: 1rem;\n  background-color: rgba(215, 217, 217, 0.2);\n  border-left: 4px solid #004681;\n  border-radius: 4px;\n}\n\n.presta-col.clickable {\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n}\n\n.presta-col.clickable:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);\n}\n\n.presta-col.best-note {\n  border: 3px solid #da7027;\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.15);\n}\n\n.presta-selection-indicator {\n  margin-top: 1.5rem;\n  text-align: center;\n  padding: 0.8rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.selected-label {\n  font-weight: 600;\n  color: #004681;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.selected-label::before {\n  content: \"\";\n  display: inline-block;\n  width: 18px;\n  height: 18px;\n  background-color: #004681;\n  border-radius: 50%;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'/%3E%3C/svg%3E\");\n  background-size: 12px 12px;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.not-selected-label {\n  color: #6b7280;\n  font-size: 0.9rem;\n}\n\n.form-row.note-ponderee {\n  grid-template-columns: 40% 60%;\n}\n\n.ponderation-badge {\n  display: inline-block;\n  font-size: 0.95rem;\n  font-weight: 500;\n  padding: 2px 6px;\n  border-radius: 8px;\n  margin-left: 6px;\n  background-color: rgba(215, 217, 217, 0.25);\n  color: #595959;\n}\n\n.info-icon-container {\n  position: relative;\n  display: inline-block;\n  margin-left: 4px;\n  cursor: help;\n}\n\n.info-icon {\n  display: block;\n}\n\n.info-icon-container .tooltip {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  background-color: #595959;\n  color: white;\n  padding: 8px 12px;\n  border-radius: 4px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n  width: 300px;\n  visibility: hidden;\n  opacity: 0;\n  transition: opacity 0.2s, visibility 0.2s;\n  z-index: 10;\n  font-size: 1rem;\n  pointer-events: none;\n  margin-top: 5px;\n}\n\n.info-icon-container:hover .tooltip {\n  visibility: visible;\n  opacity: 1;\n}\n\n/* Flèche du tooltip */\n.info-icon-container .tooltip::before {\n  content: \"\";\n  position: absolute;\n  bottom: 100%;\n  left: 10px;\n  border-width: 6px;\n  border-style: solid;\n  border-color: transparent transparent #2c3948 transparent;\n}\n\n.note-detail {\n  font-size: 1.2rem;\n  color: #6b7280;\n  margin-left: 0.5rem;\n}\n\n.ponderation-badge {\n  display: inline-block;\n  padding: 0.2rem 0.6rem;\n  border-radius: 1rem;\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin-left: 0.5rem;\n  background-color: rgba(215, 217, 217, 0.2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
